<template>
  <div>
    <Header></Header>
    <Expand></Expand>

    <div class="noticebox" id="noticebox" v-if="news.content">
      <div class="container">
        <i class="ti-volume"></i>
        <p v-html="news.content"></p>
      </div>
    </div>

    <router-view />

    <Footer></Footer>
  </div>
</template>

<script>
import { newslist } from "@/api/common/index";
import Header from "./Header.vue";
import Footer from "./Footer.vue";
export default {
  name: "Layout",
  components: {
    Header,
    Footer,
    Expand: () => import("@/views/CloudDisk/Expand"),
  },
  data() {
    return {
      news: {
        title: "",
        content: "",
        created_at: "",
      },
    };
  },
  created() {
    this.newslist();
  },
  methods: {
    newslist() {
      newslist()
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.length) {
              this.news = res.entity[0];
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  updated() {
    this.$nextTick(function () {
      let wh = $(window).height();
      let a = $("#header").height();
      let b = $("#footer").height();
      let c = 0;
      if ($('#noticebox').length > 0) {
        c = $('#noticebox').height();
      }
      $("#page-wrap").css("min-height", wh - a - b - c + "px");
    });
  },
  mounted() {
    this.$nextTick(function () {
      let wh = $(window).height();
      let a = $("#header").height();
      let b = $("#footer").height();
      let c = 0;
      if ($('#noticebox').length > 0) {
        c = $('#noticebox').height();
      }
      $("#page-wrap").css("min-height", wh - a - b - c + "px");
    });
  },
};
</script>

<style scoped>
</style>
